import type { TestimonialCardProps } from "./TestimonialCard.d";
import { TestimonialCard } from "./TestimonialCard";

export { TestimonialCardProps, TestimonialCard };
